var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaltelCorporateRequestAdditionalAddresses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.933 15.995a8.591 8.591 0 0 1-.271-2.084 8.591 8.591 0 0 1 .27-2.085h3.524c-.091.691-.14 1.388-.146 2.085.006.697.055 1.393.146 2.084h2.105a15.329 15.329 0 0 1-.167-2.084c.008-.698.064-1.395.167-2.085h4.878c.103.69.159 1.387.166 2.085a15.345 15.345 0 0 1-.166 2.084h2.105c.09-.691.14-1.387.146-2.084a17.219 17.219 0 0 0-.146-2.085h3.523c.175.681.266 1.381.27 2.085a8.588 8.588 0 0 1-.27 2.084h2.146a10.422 10.422 0 1 0-20.427 0h2.147zm15.28-6.253h-3.075a16.315 16.315 0 0 0-1.439-3.71 8.369 8.369 0 0 1 4.513 3.71zM16 5.614a14.677 14.677 0 0 1 1.99 4.128h-3.98A14.683 14.683 0 0 1 16 5.614zm-2.7.417a16.31 16.31 0 0 0-1.438 3.71H8.787a8.324 8.324 0 0 1 4.513-3.71zm3.48 15.691h2.085v1.043h-2.084v-1.043z",
    fill: "url(#rt2y2brqca)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.378 18.08H6.622a2.087 2.087 0 0 0-2.087 2.086v6.25a2.087 2.087 0 0 0 2.087 2.086h18.756a2.087 2.087 0 0 0 2.087-2.087v-6.249a2.087 2.087 0 0 0-2.087-2.087zm-12.243 8.343H11.57v-6.254h1.564v6.254zm7.293-3.659a1.536 1.536 0 0 1-1.563 1.564h-2.084v2.084h-1.564V20.16h3.648a1.536 1.536 0 0 1 1.563 1.563v1.042z",
    fill: "url(#76wlv3k9yb)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rt2y2brqca",
    x1: 21.549,
    y1: 41.898,
    x2: -2.329,
    y2: 33.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "76wlv3k9yb",
    x1: 21.549,
    y1: 41.898,
    x2: -2.329,
    y2: 33.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A87A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaltelCorporateRequestAdditionalAddresses);
export default __webpack_public_path__ + "static/media/paltelCorporateRequestAdditionalAddresses.ba6e614e61f12a4acc03e5a15b6c3ed0.svg";
export { ForwardRef as ReactComponent };